<div class="dialogWrapper">
    <h2>{{ 'generalKeywords.signin' | translate }}</h2>
    <app-otp
        [allowUserSwitching]="false"
        [email]="data.email"
        (onCancelOtp)="closeModalInstance(false)"
        (onOtpSuccess)="closeModalInstance(true)"
    />
</div>
